import React from 'react';
import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import { distHistoryUtil } from './util';

import styles from './ETFDistributionHistory.css';
import { ETF_DISTRIBUTION } from './queries';

const ETFDistributionHistory = (props) => {
    const { ticker, templateName } = props;
    return (
        <div className="section-container">
            <Card addOverflow>
                <TitleWithDescription title="Distribution History" borderLine />

                <div className="card-section dividends">
                    <GqlQueryWrapper
                        query={ETF_DISTRIBUTION}
                        dataFunc={distHistoryUtil(ticker)}
                        variables={{ ticker }}
                        placeholder={() => <TablePreRender height="100px" />}
                    >
                        {({ data: { data, headers, scheduleFrequency } }) => (
                            <React.Fragment>
                                <Table data={{ data, headers }} />
                                {templateName !== 'EQUITY_INCOME_ETF' && (
                                    <div className="schedule-section">
                                        <TitleWithDescription title="Distribution Schedule" />
                                        <div className="schedule-freq">
                                            {scheduleFrequency}
                                        </div>
                                    </div>
                                )}
                                <div className="disclaimer">
                                    <p>Distribution dates subject to change.</p>
                                    <p>
                                        All registered investment companies are
                                        obliged to distribute portfolio gains to
                                        shareholders by year’s end regardless of
                                        performance. Trading ETFs will also
                                        generate tax consequences and
                                        transaction expenses.
                                    </p>
                                    <p className="dist-footer-text">
                                        This material is provided for general
                                        and educational purposes only and not
                                        intended to provide legal, tax, or
                                        investment advice. This material does
                                        not provide recommendations concerning
                                        investments, investment strategies, or
                                        account types; it is not individualized
                                        to the needs of any specific investor
                                        and not intended to suggest any
                                        particular investment action is
                                        appropriate for you, nor is it intended
                                        to serve as the primary basis for
                                        investment decision-making.
                                    </p>
                                    <p className="dist-footer-text">
                                        The information, including all linked
                                        pages and documents, on T. Rowe Price
                                        Web sites is not intended to be tax
                                        advice and cannot be used to avoid any
                                        tax penalties. You should consult your
                                        own tax advisor. Please see Legal
                                        Information for more details.
                                    </p>
                                </div>
                            </React.Fragment>
                        )}
                    </GqlQueryWrapper>
                </div>
            </Card>
            <style jsx>{styles}</style>
        </div>
    );
};

export default ETFDistributionHistory;
